import { createInertiaApp } from '@inertiajs/react'
import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { Hydrated } from '@/components/shared/Hydrated'
import { errorReporter, reactRootErrorOptions } from '@/lib/errorReporter'
import { resolvePage } from '@/lib/resolvePage'

// Uncaught errors, unhandled rejections and render crashes land in the issue log (POST /ops/client_errors).
const reporter = errorReporter()
reporter.install(window)
const rootOptions = reactRootErrorOptions(reporter)

void createInertiaApp({
  resolve: resolvePage,
  // The bar is styled with our tokens in application.css (#nprogress); it shows after 120 ms so a fast visit never flickers.
  progress: { delay: 120, includeCSS: false, showSpinner: false },
  setup({ el, App, props }) {
    if (!el) return
    const app = (
      <StrictMode>
        <Hydrated>
          <App {...props} />
        </Hydrated>
      </StrictMode>
    )
    if (el.hasAttribute('data-server-rendered')) {
      hydrateRoot(el, app, rootOptions)
    } else {
      createRoot(el, rootOptions).render(app)
    }
  },
})
